<cmv-modal-base *ngIf="isMemberModalVisible">
	<section class="member-modal">
		<button class="member-modal__btn-close" (click)="hideMemberModal()">
			<i class="bi bi-x"></i>
		</button>
		<h1 class="member-modal__title">¡Únete a Nuestra Comunidad!</h1>
		<div class="member-modal__content">
			<p>
				Para formar parte de nuestra familia, se requiere una aportación de
				<b>$500.</b>
			</p>
			<p>
				Para tu comodidad la aportación se divide en
				<b> tres pagos mensuales de $167 </b> dentro de tu tarjeta.
			</p>
			<p>
				Si en algún momento decides darte de baja, podrás solicitar el reembolso
				completo e inmediato de tu aportación*.
			</p>
			<p>
				Disfruta de los <b>beneficios exclusivos</b> de la Tarjeta de Crédito
				que
			</p>
		</div>
		<em>TE DA <span>+</span> CUANDO <span>+</span> LA USAS</em>
		<button class="member-modal__btn-agree" (click)="hideMemberModal()">
			De acuerdo
		</button>
	</section>
</cmv-modal-base>
